<template>
  <div>
    <a :href="$url($t('pages.userProfile.url'))">{{ $t('pages.userProfile.title') }}</a> |
    <a :href="$url($t('pages.warrants.url'))">{{ $t('pages.warrants.title') }}</a> |
    <a :href="$url($t('pages.substitutes.url'))">{{ $t('pages.substitutes.title') }}</a> |
    <a :href="$url($t('pages.settings.url'))">{{ $t('pages.settings.title') }}</a> |
    <a :href="$url($t('pages.services.url'))">{{ $t('pages.services.title') }}</a> |
    <a :href="$url($t('pages.messages.url'))">{{ $t('pages.messages.title') }}</a> |
    <a :href="$url($t('pages.myRequests.url'))">{{ $t('pages.myRequests.title') }}</a> |
    <a :href="$url($t('pages.myServices.url'))">{{ $t('pages.myServices.title') }}</a> |
    <a :href="$url($t('pages.specialistSearch.url'))">{{ $t('pages.specialistSearch.title') }}</a> |
    <a :href="$url($t('pages.importProfile.url'))">{{ $t('pages.importProfile.title') }}</a> |
    <a :href="$url($t('pages.requests.url'))">{{ $t('pages.requests.title') }}</a> |
    <a :href="$url($t('pages.changePassword.url'))">{{
      $t('pages.changePassword.title').replace('{0}', '')
    }}</a>
    |
    <a :href="$url($t('pages.setPassword.url') + '?token=token')">{{
      $t('pages.setPassword.title')
    }}</a>
    | <a :href="$url($t('pages.bnkCatalogue.url'))">{{ $t('pages.bnkCatalogue.title') }}</a> |
    <a :href="$url($t('pages.myBnkSubscriptions.url'))">{{
      $t('pages.myBnkSubscriptions.title')
    }}</a>
  </div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style scoped></style>
